import { render } from "./DecorItem.vue?vue&type=template&id=1484ed62"
import script from "./DecorItem.vue?vue&type=script&lang=js"
export * from "./DecorItem.vue?vue&type=script&lang=js"

import "./DecorItem.vue?vue&type=style&index=0&id=1484ed62&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__